<template>
  <div>
    <vxe-card size="mini" width="100%">
      <div slot="title">
        <vxe-button content="tab.pickingModeConfig" mode="text" status="primary"/>
      </div>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh(warehouse)"/>
        <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
      </template>
      <vxe-table
        ref="table"
        :column-config="{resizable:true}"
        :data="list"
        :export-config="{}"
        :keyboard-config="{isArrow: true}"
        :loading="loading"
        :row-config="{isCurrent: true, isHover: true}"
        :scroll-x="{enabled: true}"
        align="center"
        border
        round
        show-header-overflow
        show-overflow
        stripe>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:pickingModes}" field="pickingMode" title="business.label.pickingMode" width="200"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:visualizedData}" field="visualized" title="business.label.visualized" width="200"/>
        <vxe-column field="orderProperties" title="business.label.orderProperty" width="200">
          <template #default="{ row }">{{getStrings(row.orderProperties, 'name')}}</template>
        </vxe-column>
        <vxe-column field="storageRooms" title="business.label.storageRoom">
          <template #default="{ row }">{{getStrings(row.storageRooms, 'name')}}</template>
        </vxe-column>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row,false)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="edit(row,true)"/>
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <vxe-modal v-model="visible" :destroyOnClose="true" :loading="loading" :title="$t('tab.pickingModeConfig')" show-footer size="mini" type="confirm" width="40%" @cancel="cancel" @confirm="confirm">
      <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="config" :rules="rules" :wrapper-col="wrapperCol">
        <a-row style="margin-left: -4%;margin-right: 4%">
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.pickingMode')" prop="pickingMode">
              <vxe-select v-model="config.pickingMode" :options="pickingModes" clearable style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.visualized')">
              <vxe-select v-model="config.visualized" :options="visualizedData" clearable style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="24">
            <a-form-model-item :label="$t('business.label.orderProperty')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
              <vxe-select v-model="orderPropertyIds" :options="orderProperties" clearable multiple style="width: 100%" @change="onOrderPropertyChange"/>
            </a-form-model-item>
          </a-col>
          <a-col span="24">
            <a-form-model-item :label="$t('business.label.storageRoom')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
              <vxe-input :value="getStrings(config.storageRooms,'name')" clearable style="width: 100%" @dblclick.native="onStorageRoomSelect"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-modal>
    <storage-room-modal ref="storageRoomModal" select-type="checkbox" @change="onStorageRoomChange"/>
  </div>
</template>
<script>
import { deleteOne, findAll, findOne, save } from '@/api/Api'
import { Warehouse } from '@/api/dto/common/Warehouse'
import { PickingModeConfig } from '@/api/dto/config/PickingModeConfig'
import { Dictionary } from '@/api/dto/admin/Dictionary'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import { getStrings } from '@/utils/util'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'

export default {
  name: 'PickingModeConfig',
  components: { StorageRoomModal },
  data() {
    return {
      loading: false,
      visible: false,
      warehouse: new Warehouse(),
      list: [],
      config: new PickingModeConfig(),
      visualizedData: [
        { value: true, label: '是' },
        { value: false, label: '否' },
        { value: null, label: '无' }
      ],
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        pickingMode: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  props: {
    pickingModes: {
      type: Array,
      default: []
    },
    orderProperties: {
      type: Array,
      default: []
    }
  },
  computed: {
    orderPropertyIds() {
      return this.config.orderProperties ? this.config.orderProperties.map(item => item.id) : []
    }
  },
  methods: {
    getStrings,
    onOrderPropertyChange(event) {
      this.config.orderProperties = event.value ? event.value.map(item => {
        return new Dictionary({ id: item })
      }) : []
    },
    onStorageRoomSelect() {
      this.$refs.storageRoomModal.open({ 'warehouse.id': this.warehouse.id, available: true, physical: true }, this.config, this.config.storageRooms)
    },
    onStorageRoomChange(value) {
      this.config.storageRooms = value.map(item => {
        return new StorageRoom(item)
      })
    },
    refresh(warehouse) {
      this.warehouse = warehouse
      if (this.warehouse.isNew()) {
        return this.$message.warning('请先选择仓库')
      }
      this.loading = true
      findAll('pickingModeConfigFactory', { 'warehouse.id': this.warehouse.id }).then(res => {
        if (res.success) {
          this.list = res.result.map(item => {
            return new PickingModeConfig(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.visible = true
      this.config = new PickingModeConfig()
    },
    edit(row, copy) {
      this.visible = true
      this.loading = true
      findOne('pickingModeConfigFactory', { id: row.id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.config = new PickingModeConfig(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const config = this.config.toJSONObject()
      config.warehouse = this.warehouse
      save('pickingModeConfigPersister', config).then(res => {
        if (res.success) {
          this.config = new PickingModeConfig(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.refresh(this.warehouse)
          this.cancel()
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) this.save()
      })
    },
    cancel() {
      this.visible = false
    },
    remove(row) {
      if (row.id) {
        this.loading = true
        deleteOne('pickingModeConfigDeleter', { id: row.id }).then(res => {
          if (res.success) {
            this.refresh(this.warehouse)
            this.$message.success(this.$t('message.deleteSuccess'))
          }
        }).finally(() => this.loading = false)
      } else {
        this.list.splice(this.list.indexOf(row), 1)
      }
    }
  }
}
</script>